import { RouteAnimationShared } from './utils/route-animation-shared';
import { MetrixService } from './data/repository/analytics-repository/metrix.service';
import { Component, HostBinding, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IosInstallComponent } from './utils/ios-install/ios-install.component';
import { slideInAnimation } from './utils/route-animations';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import metrix from 'src/assets/analytics/metrix';
import { AppService } from './app.service';
declare var gtag;
declare var _metrix;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [slideInAnimation],
})
export class AppComponent implements OnInit {
  @HostBinding('@.disabled') private disabled = false;

  title = 'Diet-new';

  constructor(
    private toast: MatSnackBar,
    router: Router,
    private metrixService: MetrixService,
    private routeAnimationShared: RouteAnimationShared,
    private sw: AppService
  ) {
    const navEndEvent$ = router.events.pipe(
      filter((e) => e instanceof NavigationEnd)
    );
    navEndEvent$.subscribe((e: NavigationEnd) => {
      setTimeout(() => {
        this.routeAnimationShared.hideRouteAnimation();
      }, 100);
      gtag('config', 'UA-145924374-2', { page_path: e.urlAfterRedirects });
    });

    this.routeAnimationShared.showRouteAnimationObs$.subscribe((show) => {
      if (show && this.isIos()) {
        this.disabled = false;
      }
    });
    this.routeAnimationShared.hideRouteAnimationObs$.subscribe((hide) => {
      if (hide && this.isIos()) {
        this.disabled = true;
      }
    });
    this.sw.checkForUpdates();
  }

  ngOnInit() {
    const _metrix = metrix.initialize({
      appId: 'uacmxxbwrkjiecc',
      // uniqueDeviceId: 'fe3343ff444r4',
      // trackerToken: 'rebhyh'
    });
    this.metrixService.metrix = _metrix;

    // Detects if device is in standalone mode
    const isInStandaloneMode = () =>
      'standalone' in (window as any).navigator &&
      (window as any).navigator.standalone;

    // Checks if should display install popup notification:
    if (this.isIos() && !isInStandaloneMode()) {
      setTimeout(() => {
        this.toast.openFromComponent(IosInstallComponent, {
          duration: 800000,
          horizontalPosition: 'start',
          panelClass: ['mat-elevation-z3'],
        });
      });
    }
  }
  // Detects if device is on iOS
  isIos() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(userAgent);
  }
}
